module.exports = __webpack_public_path__ + "static/media/efrs_logo.d2c576a4.svg";